import React, {useState} from "react"

const DashboardContext = React.createContext({
  availableCount: 0,
  setAvailableCount: (_count) => {},
  missingCount: 0,
  setMissingCount: (_count) => {},
  inUseCount: 0,
  setInUseCount: (_count) => {},
  availableDeviceList: [],
  setAvailableDeviceList: (_list) => {},
  missingDeviceList: [],
  setMissingDeviceList: (_list) => {},
  avaialableDeviceCursor: {},
  setAvailableDeviceCursor: (_cursor) => {},
  inUseDeviceCursor: {},
  setInUseDeviceCursor: (_cursor) => {},
  missingDeviceCursor: {},
  setMissingDeviceCursor: (_cursor) => {},
  inUseDeviceList: [],
  setInUseDeviceList: (_list) => {},
  selectedCard: "",
  setSelectedCard: (_card) => {},
  loading: false,
  isSetLoading: (_boolean) => {}
})

export const DashboardProvider = ({children}) => {
  const [availableCount, setAvailableCount] = useState(0);
  const [inUseCount, setInUseCount] = useState(0);
  const [missingCount, setMissingCount] = useState(0);
  const [availableDeviceList, setAvailableDeviceList] = useState([]);
  const [inUseDeviceList, setInUseDeviceList] = useState([]);
  const [missingDeviceList, setMissingDeviceList] = useState([]);
  const [avaialableDeviceCursor, setAvailableDeviceCursor] = useState({});
  const [inUseDeviceCursor, setInUseDeviceCursor] = useState({});
  const [missingDeviceCursor, setMissingDeviceCursor] = useState({});
  const [selectedCard, setSelectedCard] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <DashboardContext.Provider
      value={{
        availableCount,
        setAvailableCount,
        inUseCount,
        setInUseCount,
        missingCount,
        setMissingCount,
        availableDeviceList,
        setAvailableDeviceList,
        inUseDeviceList,
        setInUseDeviceList,
        missingDeviceList,
        setMissingDeviceList,
        avaialableDeviceCursor, 
        setAvailableDeviceCursor,
        inUseDeviceCursor, 
        setInUseDeviceCursor,
        missingDeviceCursor,
        setMissingDeviceCursor,
        selectedCard,
        setSelectedCard,
        isLoading,
        setIsLoading
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}

export const useDashboardContext = () => {
  const context = React.useContext(DashboardContext)
  if (!context) {
    throw new Error(
      "useDashboardContext must be used within a DashboardContextProvider"
    )
  }
  return context
}
